function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M338.125,264.031l120.188-120.188c3.767-3.766,5.828-8.953,5.688-14.391   c-0.109-5.469-2.391-10.734-6.344-14.672l-44.422-44.422c-8.203-8.219-21.22-8.5-29.063-0.656L263.984,189.891L143.82,69.75   c-7.844-7.844-20.852-7.547-29.055,0.641l-44.422,44.406c-3.938,3.938-6.211,9.219-6.336,14.672   c-0.117,5.438,1.922,10.625,5.703,14.391l120.156,120.156L69.711,384.172c-7.844,7.844-7.563,20.844,0.656,29.063l44.398,44.405   c8.227,8.22,21.234,8.5,29.086,0.656l120.156-120.156l120.148,120.156c7.844,7.844,20.858,7.563,29.063-0.641l44.422-44.422   c3.953-3.953,6.22-9.22,6.345-14.656c0.108-5.453-1.938-10.641-5.703-14.406L338.125,264.031z",
  fill: "#4D4D4D"
}));

var SvgCloseIcon = function SvgCloseIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: "512px",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-icon.d5d2e8e0.svg";
export { ForwardRef as ReactComponent };